export * from './bank'
export * from './consorcio'
export * from './seguros'
export * from './tvGazin'
